export interface ObservationRow {
    Type: string;
    Code: string;
    Value: string;
    ValueType: string;
  }
  export interface CodeOption {
    value: string;
    label: string;
    realId?: string; 
    code?: string; 
  }
  export interface ActivityRow {
    ActivityId: string;
    activityCode: string; 
    activityType: number;   
    quantity: number;
    preApprovalNumber: string;
    observations: ObservationRow[];
    hasSupportingDocuments: boolean;
    toothNumbers?: string[];
  }
  export type AllowedActivityType = "CPT" | "HCPCS" | "Dental" | "Service";

  export const ACTIVITY_TYPE_TO_CODE: Record<string, number> = {
    CPT: 3,
    HCPCS: 4,
    Dental: 6,
    Service: 8, 
  };
  
  export const CODE_TO_ACTIVITY_TYPE: Record<string, string> = {
    "3": "CPT",
    "4": "HCPCS",
    "6": "Dental",
    "8": "Service", 
  };